var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// apexcharts/client/apex-chart.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { state } from "lit/decorators/state.js";
import { ref } from "lit/directives/ref.js";
import { until } from "lit/directives/until.js";
var ApexChart = class extends ChemistryLitElement {
  render() {
    return html`
      <style>
        ${until(import("text:apexcharts/dist/apexcharts.css")), ""}
      </style>
      <div>
        <div id="apexChart" ${ref((e) => this.container = e)}></div>
      </div>
    `;
  }
  async updated(changedProperties) {
    super.updated(changedProperties);
    const ApexCharts = (await import("apexcharts")).default;
    if (!this.chart) {
      this.chart = new ApexCharts(
        this.container,
        this.options ?? { chart: { type: "bar" }, series: [{ data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }] }
      );
      this.chart.render();
      if (this.options)
        this.chart.updateOptions(this.options);
    } else if (this.options) {
      this.chart.updateOptions(this.options);
    }
  }
};
__decorateClass([
  state()
], ApexChart.prototype, "options", 2);
__decorateClass([
  state()
], ApexChart.prototype, "chart", 2);
ApexChart = __decorateClass([
  customElement("apex-chart")
], ApexChart);
export {
  ApexChart
};
